import API_ENDPOINTS from '../../config/api';

/**
 * Write a lens item: PUT `itemData` when it has an id, otherwise POST `newItem`.
 * Resolves to the saved row. Throws when the server refuses the write (a locked
 * workshop answers 403 with code LOCKED), so the caller can keep LensItemModal
 * open instead of closing it as if the save had worked.
 */
export async function saveLensItem(itemData, newItem) {
  const res = itemData.id
    ? await fetch(API_ENDPOINTS.LENS_ITEM_UPDATE(itemData.id), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(itemData),
    })
    : await fetch(API_ENDPOINTS.LENS_ITEM_CREATE(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newItem),
    });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body.error || `HTTP ${res.status}`);
    err.code = body.code || null;
    throw err;
  }
  return body;
}
